import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { FundraisersTableProps } from '../FundraisersTable/FundraisersTable.types'

import { FundraiserStatus } from '@percent/partner-dashboard/services/fundraisers/fundraisersService.types'
import { LocaleKey } from '@percent/partner-dashboard/i18n/config'

type StatusOption = {
  label: string
  value: FundraiserStatus
  text: LocaleKey
}

const fundraiserStatusOptions: StatusOption[] = [
  {
    label: 'Open',
    value: FundraiserStatus.Published,
    text: 'status.open'
  },
  {
    label: 'Closed',
    value: FundraiserStatus.Closed,
    text: 'status.closed'
  }
]

export const useStatusFilter = ({
  queryParams,
  setQueryParams
}: Pick<FundraisersTableProps, 'queryParams' | 'setQueryParams'>) => {
  const { t } = useTranslation()

  const onStatusChange = useCallback(
    (selectedLabels: string[]) => {
      const selectedValues = selectedLabels
        .map(label => {
          const option = fundraiserStatusOptions.find(opt => opt.label === label)

          return option?.value
        })
        .filter(Boolean) as FundraiserStatus[]

      setQueryParams({
        status: selectedValues
      })
    },
    [setQueryParams]
  )

  const getSelectedLabels = (selectedValues: FundraiserStatus[] | undefined) => {
    if (!selectedValues) return []

    return fundraiserStatusOptions.filter(option => selectedValues.includes(option.value)).map(option => option.label)
  }

  return {
    statusOptions: fundraiserStatusOptions.map(opt => ({
      label: t(opt.text),
      value: opt.label
    })),
    onStatusChange,
    selectedStatus: getSelectedLabels(queryParams?.status)
  }
}
